// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase, TelemetryType } from "@msnews/telemetry-contracts";

export interface GradientOverlayTelemetryObjects {
    readFullContentButton: TelemetryObjectBase;
}

export const gradientOverlayTelemetryContracts = {

    readFullContentButton: {
        name: "SubscribeLink",
        behavior: TelemetryBehaviorType.Open,
        type: TelemetryType.ActionButton,
        content: {
            headline: "SubscribeLink"
        }
    }

};
